import { render, staticRenderFns } from "./DashboardPanos.vue?vue&type=template&id=d852aeae&scoped=true"
import script from "./DashboardPanos.vue?vue&type=script&lang=js"
export * from "./DashboardPanos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d852aeae",
  null
  
)

export default component.exports